<template>
    <div id="bst-wrap">
        <div class="l-project-wrap l-project-wrap--mypage is-hide">
            <header class="l-header l-header--top">
                <public-page-header />
            </header>

            <section class="l-content-area">
                <div class="l-content">
                    <section class="p-bloc p-bloc--mypage">
                        <div class="p-bloc__content l-wrap__outer">
                            <div class="l-wrap__inner">
                                <section class="p-mypage">
                                    <div class="p-mypage__content">
                                        <div class="mypage-content">
                                            <div class="p-mypage__page mypage-bloc">
                                                <div class="mypage-bloc__content">
                                                    <div class="page__bloc page__bloc--terms c-kiyaku">
                                                        <div class="blog-page">
                                                            <article id="post-inner">
                                                                <header class="article-header">
                                                                    <h1>hubsynch（ユーザーアカウント）をはじめてご利用される方はこちら</h1>
                                                                    <ul class="post-data">
                                                                        <li class="posted"><span
                                                                                class="data-h">POSTED&nbsp;:&nbsp;&nbsp;</span>2013.11.13
                                                                        </li>
                                                                    </ul>
                                                                    <sns-share-links />

                                                                    <div class="eyecatch-img">
                                                                        <span>
                                                                            <img width="860" height="480"
                                                                                src="@/assets/img/static_pages/hajimete.jpg"
                                                                                class="attachment-w860-h480 size-w860-h480 wp-post-image"
                                                                                alt="hubsynch（ユーザーアカウント）をはじめてご利用される方はこちら">
                                                                        </span>
                                                                    </div>
                                                                </header>

                                                                    <p>hubsynch（ハブシンク）をご利用頂き、誠にありがとうございます。</p>
                                                                    <p>hubsynch（ハブシンク）は「もっと交換をカンタンに」をコンセプトにしています。</p>
                                                                    <p>ユーザーアカウントをご利用の方には、より簡単でしかも安全にご決済を頂けるようにサービス提供をしております。
                                                                    </p>
                                                                    <p>詳しい情報は下記よりご覧ください。</p>
                                                                    <div class="hubsynch-index-block">
                                                                        <h3 class="hubsynch-index-title">hubsynchについて</h3>
                                                                        <nav class="hubsynch-index-menu below-title">
                                                                            <ul>
                                                                                <li><router-link title="hubsynchってなに？"
                                                                                        :to="{ name: 'about.hubsynch' }">hubsynchってなに？</router-link>
                                                                                </li>
                                                                                <li><router-link title="アカウントの種類について"
                                                                                        :to="{ name: 'category.account' }">アカウントの種類について</router-link>
                                                                                </li>
                                                                                <li><router-link title="hubsynchの特長"
                                                                                        :to="{ name: 'hubsynch.strong.point' }">hubsynchの特長</router-link>
                                                                                </li>
                                                                                <li><router-link title="hubsynchのご利用方法"
                                                                                        :to="{ name: 'hubsynch.using' }">hubsynchのご利用方法</router-link>
                                                                                </li>
                                                                                <li><router-link title="hubsynchのしくみ"
                                                                                        :to="{ name: 'hubsynch.flow' }">hubsynchのしくみ</router-link>
                                                                                </li>
                                                                                <li><router-link title="ユーザーアカウントの登録方法"
                                                                                        :to="{ name: 'how.to.sign.up' }">ユーザーアカウントの登録方法</router-link>
                                                                                </li>
                                                                                <li><router-link title="ご利用手数料について"
                                                                                        :to="{ name: 'user.account.fee' }">ご利用手数料について</router-link>
                                                                                </li>
                                                                            </ul>
                                                                        </nav>
                                                                    </div>
                                                                    <div id="btn-contact-wrap" class="btn-wrap">
                                                                        <p class="txt">ご不明な点がございましたら、お問い合わせ下さい</p>
                                                                        <p class="btn"><router-link
                                                                                :to="{ name: 'contact.us' }">お問合せ</router-link>
                                                                        </p>
                                                                    </div>
                                                            </article>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </section>
                </div>
            </section>
            <Footer v-if="isLoggedIn"/>
            <PublicFooter v-else/>
        </div>
    </div>

</template>
<script setup>
import PublicPageHeader from "@/components/PublicPageHeader.vue";
import SnsShareLinks from "@/components/SnsShareLinks.vue";
import { ref, onBeforeMount } from "vue";
import { useSessionStore } from "@/stores/sessionStore";
import Footer from "@/components/Footer.vue";
import PublicFooter from "@/components/PublicFooter.vue";

const sessionStore = useSessionStore();
const isLoggedIn = ref(false);
onBeforeMount(async () => {
    isLoggedIn.value = sessionStore.isLoggedIn();
});
</script>